export default "__VITE_ASSET__lg2ZYyD$__"